var _rect, _g, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 54,
    viewBox: "0 0 66 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 65,
    height: 53,
    rx: 9.5,
    fill: "#7371FC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_459_10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.8295 26.5609C34.4177 26.5609 35.793 25.9912 36.9167 24.8673C38.0405 23.7436 38.6101 22.3687 38.6101 20.7803C38.6101 19.1924 38.0405 17.8172 36.9166 16.6932C35.7927 15.5696 34.4175 15 32.8295 15C31.241 15 29.8661 15.5696 28.7424 16.6934C27.6187 17.8171 27.0488 19.1922 27.0488 20.7803C27.0488 22.3687 27.6187 23.7438 28.7426 24.8675C29.8665 25.991 31.2416 26.5609 32.8295 26.5609Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9435 33.4547C42.9111 32.9871 42.8456 32.477 42.7491 31.9383C42.6517 31.3956 42.5262 30.8825 42.3761 30.4136C42.221 29.9289 42.0101 29.4502 41.7493 28.9916C41.4787 28.5155 41.1608 28.1009 40.8041 27.7598C40.4312 27.403 39.9745 27.116 39.4464 26.9067C38.9202 26.6985 38.337 26.5931 37.7131 26.5931C37.4681 26.5931 37.2312 26.6936 36.7736 26.9915C36.492 27.1752 36.1626 27.3876 35.7949 27.6225C35.4805 27.8228 35.0546 28.0105 34.5286 28.1804C34.0153 28.3465 33.4942 28.4307 32.9799 28.4307C32.4655 28.4307 31.9446 28.3465 31.4308 28.1804C30.9053 28.0107 30.4794 27.823 30.1653 27.6227C29.8011 27.39 29.4716 27.1775 29.1857 26.9913C28.7287 26.6934 28.4916 26.5929 28.2466 26.5929C27.6226 26.5929 27.0396 26.6985 26.5135 26.9069C25.9858 27.1158 25.5289 27.4028 25.1556 27.76C24.7991 28.1013 24.481 28.5157 24.2108 28.9916C23.9502 29.4502 23.7393 29.9287 23.584 30.4137C23.434 30.8827 23.3086 31.3956 23.2112 31.9383C23.1147 32.4762 23.0491 32.9865 23.0167 33.4553C22.9849 33.9145 22.9688 34.3911 22.9688 34.8725C22.9688 36.1253 23.367 37.1395 24.1523 37.8875C24.928 38.6256 25.9543 39.0001 27.2023 39.0001H38.7585C40.0065 39.0001 41.0325 38.6258 41.8083 37.8875C42.5938 37.1401 42.9921 36.1257 42.9921 34.8723C42.9919 34.3888 42.9756 33.9118 42.9435 33.4547Z",
    fill: "white"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 65,
    height: 53,
    rx: 9.5,
    stroke: "#7371FC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_459_10"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(21 15)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.e601bf11389fdb92f5fccd90868b68c9.svg";
export { ForwardRef as ReactComponent };